import Config from "../Config";
import Services from "./services";

export const AdminUsersModel = {
    getAll: () => {
        return Services.getApi(Config.getBaseAdminPath() + '/users');
    },
}